import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import { Popover } from 'antd';
import { history } from 'umi';
import ModalML from '@/components/ModalML';
import Icon from '../../components/SvgIconML/SvgIconML';
import webStorage from '@/utils/storageManager';
import ChangePassword from '../changePassword/ChangePassword';

function Account() {
  const useName = webStorage.get('USER')?.username;

  // 打开修改密码弹窗
  const [openEditPassword, setOpenEditPassword] = useState(false);
  const handleOpen = () => {
    setOpenEditPassword(true);
  };
  const content = () => {
    return (
      <Box
        data-log={JSON.stringify({
          oid: 'page_system_layout',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
        className="exit-menu"
      >
        <Box
          className="exit-menu-list"
          sx={{
            borderBottom: '1px solid #F5F5F5',
            padding: '12px 0',
            display: 'flex',
            gap: '0 8px',
            cursor: 'pointer',
          }}
          onClick={() => {
            //打开密码弹框
            handleOpen();
          }}
        >
          <Icon name="changePassword" size={20} />
          <Box
            data-log={JSON.stringify({
              oid: 'btn_system_layout_update_password',
              events: ['_ev', '_ec'],
              params: {
                initUrl: window.location.origin + window.location.pathname,
              },
            })}
            sx={{
              fontSize: '14px',
              height: '20px',
              lineHeight: '20px',
              color: '#999',
              fontWeight: 400,
            }}
          >
            修改密码
          </Box>
        </Box>
        <Box
          sx={{
            padding: '12px 0',
            display: 'flex',
            gap: '0 8px',
            cursor: 'pointer',
          }}
          className="exit-menu-list"
          onClick={() => {
            window.location.href = '/login';
          }}
        >
          <Icon name="exit" size={20} />
          <Box
            data-log={JSON.stringify({
              oid: 'btn_system_layout_logout',
              events: ['_ev', '_ec'],
              params: {
                initUrl: window.location.origin + window.location.pathname,
              },
            })}
            sx={{
              fontSize: '14px',
              height: '20px',
              lineHeight: '20px',
              color: '#999',
              fontWeight: 400,
            }}
          >
            退出
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <div style={{ position: 'relative', height: '36px' }}>
      <Popover
        placement="bottomRight"
        content={content}
        trigger="hover"
        overlayStyle={{ width: '108px' }}
        arrowPointAtCenter
      >
        <Icon name="admin" size={36} fill="#fff" />
      </Popover>
      <Box
        sx={{
          fontSize: '14px',
          height: '20px',
          lineHeight: '20px',
          color: '#fff',
          fontWeight: 400,
          display: 'flex',
          alignItems: 'center',
          gap: '0 16px',
          position: 'absolute',
          right: '52px',
          top: '8px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '0 8px',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
          }}
        >
          {/* <Icon name="myTask" size={20} /> */}
          <Box
            sx={{
              fontSize: '14px',
              height: '20px',
              lineHeight: '20px',
              color: '#fff',
              whiteSpace: 'nowrap',
            }}
            onClick={() => {
              history.push('/my_task');
            }}
          >
            我的任务
          </Box>
        </Box>
        <Box
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '170px',
            display: 'block',
            whiteSpace: 'nowrap',
          }}
        >
          {useName}
        </Box>
        <Box
          sx={{
            width: '1px',
            height: '20px',
            background: '#FFFFFF',
            opacity: '0.5',
          }}
        ></Box>
      </Box>

      <ModalML
        open={openEditPassword}
        setOpen={() => setOpenEditPassword(true)}
        onCancel={() => setOpenEditPassword(false)}
        title={'修改密码'}
        onClose={() => setOpenEditPassword(false)}
        handleCancel={() => setOpenEditPassword(false)}
      >
        <ChangePassword handleCancel={() => setOpenEditPassword(false)} />
      </ModalML>
    </div>
  );
}

export default Account;
